import axios from 'axios'
import Qs from 'qs'

export function getCount() {
  return axios({
    url: 'http://zysj.zhiyuanshijie.com/appsite/activity/selectCount',
    method: 'post'
  })
}

export function addCount(ip) {
  return axios({
    url: 'http://zysj.zhiyuanshijie.com/appsite/activity/insertRecall',
    method: 'post',
    data: Qs.stringify({
      ip
    })
  })
}